import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes } from './routes/publicRoutes';
import { privateRoutes } from './routes/privateRoutes';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import useAuthInitializer from './hooks/auth/useAuthInitializer';
import useTitle from './hooks/useTitle';
import 'normalize.css';
import './App.css';

function AppWrapper() {
  useAuthInitializer();
  useTitle();

  return (
    <Routes>
      {/* Public Routes */}
      {publicRoutes.map(({ path, element, children }, i) => (
        children ? (
          <Route key={i} path={path} element={element}>
            {children.map((child, j) => (
              <Route key={j} {...child} />
            ))}
          </Route>
        ) : (
          <Route key={i} path={path} element={element} />
        )
      ))}

      {/* Private Routes */}
      {privateRoutes.map(({ path, element, children, protected: isProtected, roles }, i) => {
        const wrappedElement = isProtected
          ? <ProtectedRoute allowedRoles={roles}>{element}</ProtectedRoute>
          : element;

        return children ? (
          <Route key={i} path={path} element={wrappedElement}>
            {children.map((child, j) => (
              <Route key={j} {...child} />
            ))}
          </Route>
        ) : (
          <Route key={i} path={path} element={wrappedElement} />
        );
      })}

      {/* Catch All */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;